import React from 'react';
import { Card } from 'react-bootstrap';
import '../css sheets/resume.css'

function Resume() {
  return (
    <div className='custom-resume-div'>
    <span className='header-span'>My Resume</span>

      <Card className="custom-resume-card">
      <Card.Body>
        <div className="resume-content">
          <Card.Text className='resume-card-text'>
                                            <h4 style={{ textAlign: 'center'}}>
                                                ANDREW S. THOMAS
                                            </h4>
                                            <p className="about_info" style={{ textAlign: 'center'}}>
                                                Daechi-dong, Gangnam-gu, Seoul, South Korea
                                            </p>
                                            <h4 style={{ textAlign: 'left'}}>
                                                EDUCATION:
                                            </h4>
                                            <h6 style={{ textAlign: 'left'}}>
                                                2014-2019 &#160; Northern Arizona University
                                            </h6>
                                            <h6 style={{ textAlign: 'left'}}>
                                                Bachelor of Science in Geology
                                            </h6>

                                            <li className='resume-list'>Cumulative GPA 3.53</li>
                                            <li className='resume-list'>Undergraduate research on Regional water loss along <br></br>&#160; &#160; &#160;the Mogollon rim of Northern Arizona. </li>
                                            <li className='resume-list'>Awarded NAU Full tuition Lumberjack scholarship for academic <br></br>&#160; &#160; &#160;performance </li>
                                            <li className='resume-list'>Initiated into Arizona Gamma Chapter of Phi Delta Theta National<br></br>&#160; &#160; &#160; Fraternity Fall 2015</li>
                                            
                                            <br></br>

                                            <h6 style={{ textAlign: 'left'}}>
                                                2016 &#160; Korea University - 고려대하교
                                            </h6>
                                            <li className='resume-list'>Awarded Korea University Merit Scholarship for academic <br></br>&#160; &#160; &#160; performance</li>
                                            <li className='resume-list'>Completed two Korean language courses</li>
                                            <li className='resume-list'>Special emphasis on Korean and East Asian history and geopolitics</li>

                                            <br></br>

                                            <h4 style={{ textAlign: 'left'}}>
                                                VISA:
                                            </h4>
                                            <li className='resume-list'>F-2 Visa holder</li>

                                            <br></br>

                                            <h4 style={{ textAlign: 'left'}}>
                                                CERTIFICATIONS:
                                            </h4>

                                            <li className='resume-list'>MITxPro Professional Certificate in Coding: Full Stack Development with MERN - November 2021</li>
                                            <li className='resume-list'>150-Hour TEFL/TESOL IARC, August, 2018</li>

                                            <br></br>
                                            <h4 style={{ textAlign: 'left'}}>
                                                SKILLS AND STRENGTHS:
                                            </h4>
                                            <h6 style={{ textAlign: 'left'}}>
                                                Computer Skills
                                            </h6>
                                            <li className='resume-list'>Full Stack Web Development with MERN</li>
                                            <li className='resume-list'>ReactJS</li>
                                            <li className='resume-list'>React Bootstrap</li>
                                            <li className='resume-list'>Javascript</li>
                                            <li className='resume-list'>MongoDB</li>
                                            <li className='resume-list'>Mongo Atlas DB</li>
                                            <li className='resume-list'>HTML</li>
                                            <li className='resume-list'>CSS</li>
                                            <li className='resume-list'>Experience with Rest API and GraphQL</li>
                                            <li className='resume-list'>Experience working with AWS</li>
                                            <li className='resume-list'>Experience deploying applications on Heroku</li>
                                            <li className='resume-list'>Experience coding with Python, particularly with Pandas and <br></br>&#160; &#160; &#160; Numpy libraries for the manipulation and analysis of large data sets, (Excel, CSVs etc.)</li>

                                            <br></br>

                                            <h6 style={{ textAlign: 'left'}}>
                                                General Skills
                                            </h6>
                                            <li className='resume-list'>Native English Speaker</li>
                                            <li className='resume-list'>Topik level 3 Korean</li>
                                            <li className='resume-list'>Excellent writing skills, both technical and academic</li>
                                            <li className='resume-list'>High proficiency in Microsoft applications, Excel, Word, and PowerPoint </li>
                                            <li className='resume-list'>Motivated, hardworking and efficient</li>
                                            <li className='resume-list'>Skilled at working with teams of diverse nationalities</li>
                                            <li className='resume-list'>Easygoing and sociable, good at working with people</li>

                                            <br></br>

                                            <h4 style={{ textAlign: 'left'}}>
                                                WORK EXPERIENCE:
                                            </h4>
                                            <h6 style={{ textAlign: 'left'}}>
                                                AUG 2020-PRESENT Milestone Institute, Daechi-dong, Gangnam-gu
                                            </h6>
                                            <li className='resume-list'>Teacher</li>
                                            <li className='resume-list'>Responsible for teaching 30 hours of class per week solo</li>
                                            <li className='resume-list'>Teaching English grammar, vocabulary, reading, writing and speaking</li>
                                            <li className='resume-list'>Proofreading essays and providing feedback</li>
                                            <li className='resume-list'>Proctoring and grading tests and inputting scores</li>
                                            <li className='resume-list'>Responsible for writing progress reports for parents on a monthly basis</li>
                                            <br></br>

                                            <h6 style={{ textAlign: 'left'}}>
                                                JUN 2019-JUN 2020 SLP Gwangmyeong, Gyeongi-do, South Korea
                                            </h6>
                                            <li className='resume-list'>Teacher</li>
                                            <li className='resume-list'>Teaching English grammar, vocabulary, reading, writing and speaking. Additionally, <br></br>&#160; &#160; &#160; covering subjects such as science, geography, history and art in English </li>
                                            <li className='resume-list'>Creating and distributing lesson plans to students every month </li>
                                            <li className='resume-list'>Planning and teaching open classes for parents </li>
                                                                                                                
                                            <br></br>

                                            <h6 style={{ textAlign: 'left'}}>
                                                OCT 2017-JUN 2019 Texas Roadhouse Flagstaff, AZ, USA
                                            </h6>
                                            <li className='resume-list'>Server</li>
                                            <li className='resume-list'>Responsible for taking customer orders and making sure they are made <br></br>&#160; &#160; &#160;  properly and delivered within a timely manner </li>
                                            <li className='resume-list'>Provide excellent customer service by communicating well and taking <br></br>&#160; &#160; &#160; special care to ensure that all requests and concerns of guests are addressed reasonably </li>
                                            
                                            <br></br>

                                            <h4 style={{ textAlign: 'left'}}>
                                                INTERESTS:
                                            </h4>
                                            <li className='resume-list'>Hiking</li>
                                            <li className='resume-list'>Cycling</li>
                                            <li className='resume-list'>Travel</li>
                                            <li className='resume-list'>Studying Languages, Computer Coding and History</li>
                                            <li className='resume-list'>Poetry</li>
                                            <li className='resume-list'>Cooking</li>
          </Card.Text>
        </div>
      </Card.Body>
    </Card>

  </div>
  );
}

export default Resume;
